webpackJsonp([233015634327247],{

/***/ 193:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 83:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentWrapper = __webpack_require__(12);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	__webpack_require__(193);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Banner = function Banner(_ref) {
	    var title = _ref.title,
	        image = _ref.image;
	    return _react2.default.createElement(
	        'div',
	        { className: 'banner', style: { backgroundImage: 'url(' + image + ')' } },
	        _react2.default.createElement(
	            _ContentWrapper2.default,
	            null,
	            title && _react2.default.createElement('h2', { className: 'banner__title heading-font', dangerouslySetInnerHTML: { __html: title } })
	        )
	    );
	};
	
	exports.default = Banner;
	module.exports = exports['default'];

/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/nioxin.eb28aa4c.png";

/***/ }),

/***/ 469:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/redken.c6100484.png";

/***/ }),

/***/ 470:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/salon-view.fe516763.jpg";

/***/ }),

/***/ 398:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 303:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _reactHelmet = __webpack_require__(71);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(194);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Banner = __webpack_require__(83);
	
	var _Banner2 = _interopRequireDefault(_Banner);
	
	var _salonView = __webpack_require__(470);
	
	var _salonView2 = _interopRequireDefault(_salonView);
	
	var _ContentWrapper = __webpack_require__(12);
	
	var _ContentWrapper2 = _interopRequireDefault(_ContentWrapper);
	
	var _nioxin = __webpack_require__(468);
	
	var _nioxin2 = _interopRequireDefault(_nioxin);
	
	var _redken = __webpack_require__(469);
	
	var _redken2 = _interopRequireDefault(_redken);
	
	__webpack_require__(398);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var About = function About() {
	    return _react2.default.createElement(
	        'main',
	        null,
	        _react2.default.createElement(_reactHelmet2.default, { title: 'Our Products | TNT Cuts' }),
	        _react2.default.createElement(_Banner2.default, {
	            image: _salonView2.default,
	            title: 'Our Products'
	        }),
	        _react2.default.createElement(
	            _ContentWrapper2.default,
	            null,
	            _react2.default.createElement(
	                'section',
	                { className: 'products' },
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'At TNT Cuts, we take pride in offering the best services with the best products available. Our wide range of products helps to bring you the style that you want.'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'In addition, we sell most of our products for retail, so that you can take the experience from the salon to your home.'
	                ),
	                _react2.default.createElement(
	                    'p',
	                    null,
	                    'Browse through our selection of products to see what companies we trust and have available for your convenience.'
	                ),
	                _react2.default.createElement(
	                    'div',
	                    { className: 'products__highlight' },
	                    _react2.default.createElement(
	                        'h2',
	                        null,
	                        'We only sell products that we believe in.'
	                    ),
	                    _react2.default.createElement('img', { alt: 'Nioxin', className: 'product-logo product-logo--nioxin', src: _nioxin2.default }),
	                    _react2.default.createElement('img', { alt: 'Redken', className: 'product-logo product-logo--redken', src: _redken2.default })
	                )
	            )
	        )
	    );
	};
	
	exports.default = About;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-products-js-50b8d7001df6a32f7c04.js